import { createContext, useContext, useState } from "react";

export const translations = {
  en: {
    nav: { home: "Home", events: "Surprise Events", cleaning: "Cleaning", garden: "Garden Care" },
    callHelp: "Call Help",
    help: "Help",
    helpLine: "Need help? Call us — we are happy to assist with your booking.",
    heroBadge: "Clean · Care · Celebrate",
    heroLines: ["Clean.", "Care.", "Celebrate."],
    heroSub: "Surprise event setups, professional home cleaning and garden care — one trusted team, at your home or riverside.",
    heroNote: "Home service everywhere we serve · Riverside setups only at Raipur & Burul",
    bookService: "Book a Service",
    whatsappUs: "WhatsApp Us",
    chaptersEyebrow: "What we do",
    chaptersTitle: "Three services, one trusted team",
    viewServices: "View services & prices",
    viewPackages: "View Packages",
    viewAll: "View All",
    itemsWord: "items",
    page: {
      yourSelection: "Your Selection",
      addMore: "Add More Services",
      add: "Add",
      continue: "Continue",
      yourDetails: "Your Details",
      sendWhatsApp: "Continue to Send on WhatsApp",
      required: "Please fill this in",
      requiredSlot: "Please pick a time slot",
      empty: "No services selected yet — go back and pick a service.",
      backHome: "Back to services",
      backToSelection: "Back to selection",
      summary: "Booking summary",
      total: "Total",
    },
    includes: "What's included",
    choosePackage: "Choose your package",
    gardenNote:
      "Fertilizer, pesticides, new plants, new pots, soil and potting mix are always charged extra — never included unlimited in any package.",
    riversideNote:
      "All surprise setups are available at your home, and riverside too. Riverside setups are done only on the banks of the Raipur and Burul rivers.",
    chapters: {
      garden: {
        no: "01",
        eyebrow: "Care",
        title: "Garden & Plant Care",
        sub: "Healthy plants without the hassle — our gardeners come to your home.",
      },
      events: {
        no: "02",
        eyebrow: "Celebrate",
        title: "Surprise Event Management",
        sub: "Pick an occasion, choose a package, tap Book Service — we handle the rest.",
      },
      cleaning: {
        no: "03",
        eyebrow: "Clean",
        title: "Cleaning Services",
        sub: "Tap a service to see every price and book in one tap. All cleaning is done at your home.",
      },
    },
    priceOnEnquiry: "Price on enquiry",
    from: "From",
    estimatedTotal: "Estimated Total",
    booking: {
      title: "Book",
      desc: "Fill in your details — the booking goes straight to our WhatsApp (8282941060).",
      name: "Your Name",
      namePh: "Full name",
      phone: "Phone Number",
      phonePh: "10-digit mobile number",
      date: "Preferred Date",
      location: "Location",
      notes: "Notes (optional)",
      notesPh: "Any special request…",
      address: "Full Address",
      addressPh: "House no, street, landmark, area…",
      timeSlot: "Preferred Time Slot",
      pickTime: "Please choose a time slot",
      submit: "Confirm & Send on WhatsApp",
      riverside: "Riverside setups are available only at the Raipur and Burul river banks.",
      toast: "Opening WhatsApp with your booking details",
    },
    locations: { "At Home": "At Home", "Raipur Riverside": "Raipur Riverside", "Burul Riverside": "Burul Riverside" },
    footer: {
      tagline: "Clean · Care · Celebrate — surprise events, home cleaning and garden care under one roof.",
      contact: "Contact",
      areas: "Service Areas",
      areasText: "Home service available everywhere we serve. Riverside event setups only at the Raipur and Burul river banks.",
      rights: "All rights reserved.",
      bookings: "Booking List",
    },
    marquee: ["Clean", "Care", "Celebrate", "Surprise Events", "Riverside Setups", "Home Cleaning", "Garden Care", "Raipur", "Burul"],
  },
  bn: {
    nav: { home: "হোম", events: "সারপ্রাইজ ইভেন্ট", cleaning: "ক্লিনিং", garden: "বাগান" },
    callHelp: "কল করুন",
    help: "Help",
    helpLine: "সাহায্য দরকার? কল করুন — বুকিং নিয়ে যেকোনো প্রশ্নে আমরা আছি।",
    heroBadge: "ক্লিন · কেয়ার · সেলিব্রেট",
    heroLines: ["পরিষ্কার।", "যত্ন।", "উদযাপন।"],
    heroSub: "সারপ্রাইজ ইভেন্ট সেটআপ, প্রফেশনাল হোম ক্লিনিং আর বাগানের যত্ন — একটাই বিশ্বস্ত টিম, আপনার ঘরে বা নদীর ধারে।",
    heroNote: "আমাদের সার্ভিস এলাকায় সর্বত্র হোম সার্ভিস · নদীর ধারে সেটআপ শুধু রায়পুর ও বুরুল",
    bookService: "সার্ভিস বুক করুন",
    whatsappUs: "WhatsApp করুন",
    chaptersEyebrow: "আমরা যা করি",
    chaptersTitle: "তিনটি সার্ভিস, একটাই বিশ্বস্ত টিম",
    viewServices: "সার্ভিস ও দাম দেখুন",
    viewPackages: "প্যাকেজ দেখুন",
    viewAll: "সব দেখুন",
    itemsWord: "আইটেম",
    page: {
      yourSelection: "আপনার বাছাই করা সার্ভিস",
      addMore: "আরও সার্ভিস যোগ করুন",
      add: "যোগ করুন",
      continue: "কন্টিনিউ",
      yourDetails: "আপনার তথ্য",
      sendWhatsApp: "কন্টিনিউ করে WhatsApp-এ পাঠান",
      required: "এই ঘরটি পূরণ করুন",
      requiredSlot: "একটি টাইম স্লট বেছে নিন",
      empty: "এখনও কোনো সার্ভিস বাছাই হয়নি — ফিরে গিয়ে সার্ভিস বাছুন।",
      backHome: "সার্ভিসে ফিরে যান",
      backToSelection: "সিলেকশনে ফিরে যান",
      summary: "বুকিং সারসংক্ষেপ",
      total: "মোট",
    },
    includes: "যা যা থাকছে",
    choosePackage: "আপনার প্যাকেজ বাছুন",
    gardenNote:
      "সার, কীটনাশক, নতুন গাছ, নতুন টব, মাটি, পটিং মিক্স সবসময় আলাদা চার্জে — কোনো প্যাকেজেই অনলিমিটেড নয়।",
    riversideNote:
      "সব সারপ্রাইজ সেটআপ আপনার ঘরে এবং নদীর ধারে — দুই জায়গাতেই হয়। নদীর ধারে সেটআপ শুধুমাত্র রায়পুর ও বুরুল নদীর তীরে করা হয়।",
    chapters: {
      garden: {
        no: "০১",
        eyebrow: "যত্ন",
        title: "বাগান ও গাছের যত্ন",
        sub: "ঝামেলা ছাড়াই সতেজ গাছ — আমাদের মালী আপনার বাড়িতেই আসবেন।",
      },
      events: {
        no: "০২",
        eyebrow: "উদযাপন",
        title: "সারপ্রাইজ ইভেন্ট ম্যানেজমেন্ট",
        sub: "অনুষ্ঠান বেছে নিন, প্যাকেজ বাছুন, Book Service চাপুন — বাকিটা আমরা সামলাবো।",
      },
      cleaning: {
        no: "০৩",
        eyebrow: "পরিষ্কার",
        title: "ক্লিনিং সার্ভিসেস",
        sub: "সার্ভিসে চাপ দিন, দাম দেখুন, এক চাপে বুক করুন। সব ক্লিনিং আপনার ঘরে করা হয়।",
      },
    },
    priceOnEnquiry: "দাম জানতে জিজ্ঞেস করুন",
    from: "শুরু",
    estimatedTotal: "আনুমানিক মোট",
    booking: {
      title: "বুক করুন",
      desc: "বিস্তারিত পূরণ করুন — বুকিং সরাসরি আমাদের WhatsApp-এ (8282941060) চলে যাবে।",
      name: "আপনার নাম",
      namePh: "পুরো নাম",
      phone: "ফোন নম্বর",
      phonePh: "১০ সংখ্যার মোবাইল নম্বর",
      date: "পছন্দের তারিখ",
      location: "লোকেশন",
      notes: "নোট (ঐচ্ছিক)",
      notesPh: "বিশেষ কিছু জানাতে চাইলে লিখুন…",
      address: "পুরো ঠিকানা",
      addressPh: "বাড়ি নম্বর, রাস্তা, ল্যান্ডমার্ক, এলাকা…",
      timeSlot: "পছন্দের সময়",
      pickTime: "একটি সময় স্লট বেছে নিন",
      submit: "কনফার্ম করে WhatsApp-এ পাঠান",
      riverside: "নদীর ধারে সেটআপ শুধুমাত্র রায়পুর ও বুরুল নদীর তীরে পাওয়া যায়।",
      toast: "আপনার বুকিং নিয়ে WhatsApp খুলছে",
    },
    locations: { "At Home": "ঘরে", "Raipur Riverside": "রায়পুর নদীর ধারে", "Burul Riverside": "বুরুল নদীর ধারে" },
    footer: {
      tagline: "ক্লিন · কেয়ার · সেলিব্রেট — সারপ্রাইজ ইভেন্ট, হোম ক্লিনিং আর বাগানের যত্ন এক ছাদের নিচে।",
      contact: "যোগাযোগ",
      areas: "সার্ভিস এলাকা",
      areasText: "আমাদের সার্ভিস এলাকায় সর্বত্র হোম সার্ভিস পাওয়া যায়। নদীর ধারে ইভেন্ট সেটআপ শুধু রায়পুর ও বুরুল নদীর তীরে।",
      rights: "সর্বস্বত্ব সংরক্ষিত।",
      bookings: "বুকিং লিস্ট",
    },
    marquee: ["পরিষ্কার", "যত্ন", "উদযাপন", "সারপ্রাইজ ইভেন্ট", "নদীর ধারে সেটআপ", "হোম ক্লিনিং", "বাগানের যত্ন", "রায়পুর", "বুরুল"],
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  const toggle = () => setLang((l) => (l === "en" ? "bn" : "en"));
  const t = translations[lang];
  const L = (obj, field) => (lang === "bn" && obj[`${field}Bn`]) || obj[field];
  return (
    <LanguageContext.Provider value={{ lang, toggle, t, L }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
